module.exports = __webpack_public_path__ + "static/img/rank02.d2618e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v2/rank02.jpg
// module id = dsoK
// module chunks = 76